/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DbConcurrencyExceptionDetailsValuesInDb } from './DbConcurrencyExceptionDetailsValuesInDb';
import {
    DbConcurrencyExceptionDetailsValuesInDbFromJSON,
    DbConcurrencyExceptionDetailsValuesInDbFromJSONTyped,
    DbConcurrencyExceptionDetailsValuesInDbToJSON,
} from './DbConcurrencyExceptionDetailsValuesInDb';

/**
 * 
 * @export
 * @interface DbConcurrencyExceptionDetails
 */
export interface DbConcurrencyExceptionDetails {
    /**
     * 
     * @type {DbConcurrencyExceptionDetailsValuesInDb}
     * @memberof DbConcurrencyExceptionDetails
     */
    valuesInDb?: DbConcurrencyExceptionDetailsValuesInDb | null;
    /**
     * 
     * @type {string}
     * @memberof DbConcurrencyExceptionDetails
     */
    $type?: DbConcurrencyExceptionDetailsTypeEnum;
}


/**
 * @export
 */
export const DbConcurrencyExceptionDetailsTypeEnum = {
    PtwPtw100PersistenceEntityFrameworkCoreDbConcurrencyExceptionDetailsPtwPtw100PersistenceEntityFrameworkCore: 'Ptw.Ptw100.Persistence.EntityFrameworkCore.DbConcurrencyExceptionDetails, Ptw.Ptw100.Persistence.EntityFrameworkCore'
} as const;
export type DbConcurrencyExceptionDetailsTypeEnum = typeof DbConcurrencyExceptionDetailsTypeEnum[keyof typeof DbConcurrencyExceptionDetailsTypeEnum];


/**
 * Check if a given object implements the DbConcurrencyExceptionDetails interface.
 */
export function instanceOfDbConcurrencyExceptionDetails(value?: unknown): value is DbConcurrencyExceptionDetails {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DbConcurrencyExceptionDetailsTypeEnum)[0];
}

export function DbConcurrencyExceptionDetailsFromJSON(json: any): DbConcurrencyExceptionDetails {
    return DbConcurrencyExceptionDetailsFromJSONTyped(json, false);
}

export function DbConcurrencyExceptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DbConcurrencyExceptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valuesInDb': !exists(json, 'valuesInDb') ? undefined : DbConcurrencyExceptionDetailsValuesInDbFromJSON(json['valuesInDb']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DbConcurrencyExceptionDetailsToJSON(value?: DbConcurrencyExceptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'valuesInDb': DbConcurrencyExceptionDetailsValuesInDbToJSON(value.valuesInDb),
        '$type': value.$type,
    });
}

